import { render } from "./ShukkaPrePage.vue?vue&type=template&id=0013b20c&scoped=true"
import script from "./ShukkaPrePage.vue?vue&type=script&lang=js"
export * from "./ShukkaPrePage.vue?vue&type=script&lang=js"

import "./ShukkaPrePage.vue?vue&type=style&index=0&id=0013b20c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0013b20c"]])

export default __exports__